import React, { lazy } from 'react';
import { Switch, Route } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';

const Invoice = lazy(() => import('../../container/invoice'));
const EmailServerInvoice = lazy(() => import('../../container/billing-section/email-server-invoice'));

const InvoiceRoutes = () => {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route path={`${path}/invoice`} component={Invoice}/>
            <Route path={`${path}/email-server-invoice`} component={EmailServerInvoice}/>
        </Switch>
    );
};

export default InvoiceRoutes;
